import React from "react";
import {Cascader, Form, Input, InputNumber, Radio, Switch} from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from "../../../utils/NHFetch";
import NHSelect from "../../common/NHSelect";

const RadioGroup = Radio.Group;

class AddOrEditForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [],      //级联下拉数据
            flbzArr: [],
            lmljIsShowFlag: false,
            flbzIsShowFlag: true,
            lmljUpdateIsShowFlag: false,
            flbzUpdateIsShowFlag: false,
        }
    }

    static defaultProps = {
        initData: {
            pkid: '',
            lmmc: '',
            lmlx: '1',
            lmsx: '2',
            lmlj: '',
            flmid: '-1',
            ljlxFlmid: '-1',
            mrlm: '0',
            xsfs: '1',
            pxh: 1,
            zt: '0',
            mkbz: '2',
            flbz: '2'
        }
    };

    //初始加载级联下拉数据
    componentDidMount() {
        this.getInitXxfbfl();
        const {flbz, lmlx} = this.props.initData;
        this.buildIsShowFlag(lmlx);
        if (flbz) {
            this.getParentsByXxfbflbz(flbz);
        }
    }

    buildIsShowFlag = (lmlx) => {
        switch (lmlx) {
            case '1':
                this.setState({
                    flbzUpdateIsShowFlag: true
                });
                break;
            case '2':
                this.setState({
                    lmljUpdateIsShowFlag: true,
                    flbzIsShowFlag: false
                });
                break;
        }
    };

    getParentsByXxfbflbz = (flbz) => {
        NHFetch('/fwwgl/dhlm/getParentsByFbflbz', "GET", {flbz: flbz})
            .then(res => {
                if (res && res.data) {
                    this.setState({
                        flbzArr: res.data
                    });
                }
            });
    };

    //获取信息发布分类信息
    getInitXxfbfl = () => {
        NHFetch('/fwwgl/dhlm/getXxfbflInfo', 'GET', {})
            .then(res => {
                if (res) {
                    this.setState({
                        options: res.data
                    })
                }
            });
    };

    onChange = (e) => {
        let value = e.target.value;
        this.setState({
            flbzIsShowFlag: value === '1',
            lmljIsShowFlag: value === '2',
            flbzUpdateIsShowFlag: value === '1',
            lmljUpdateIsShowFlag: value === '2',
            value: value,
        });
    };

    getXxfbflbzArr = () => {
        let flbzArr = this.state.flbzArr;
        let arr = [];
        for (let i = flbzArr.length - 1; i >= 0; i--) {
            let xxfbfl = flbzArr[i];
            arr.push(xxfbfl.flbz);
        }
        return arr;
    };

    render() {
        const form = this.props.form;
        const initData = this.props.initData;
        let arr = this.getXxfbflbzArr();

        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'lmmc'} label={'栏目名称'} hasFeedback={true} form={form} required={true}
                                pattern={{max: 100, message: "栏目名称长度不能超过100字符！"}}
                                initialValue={initData.lmmc}>
                        <Input placeholder="请输入栏目名称"/>
                    </NHFormItem>
                    <NHFormItem id={'lmlx'} label={'导航栏项类型'} form={form} required={true}
                                initialValue={initData.lmlx ? initData.lmlx : '1'}>
                        <RadioGroup onChange={this.onChange}>
                            <Radio value={'1'}>
                                信息发布类型
                            </Radio>
                            <Radio value={'2'}>
                                链接类型
                            </Radio>
                        </RadioGroup>
                    </NHFormItem>
                    <div
                        style={{display: (this.state.lmljIsShowFlag || this.state.lmljUpdateIsShowFlag) ? 'block' : 'none'}}>
                        <NHFormItem id={'lmlj'} label={'栏目链接'} hasFeedback={true} form={form}
                                    pattern={{max: 100, message: "栏目链接长度不能超过100字符！"}}
                                    initialValue={initData.lmlj}>
                            <Input placeholder="请输入栏目链接"/>
                        </NHFormItem>
                    </div>
                    <div
                        style={{display: (this.state.flbzIsShowFlag || this.state.flbzUpdateIsShowFlag) ? "block" : "none"}}>
                        <NHFormItem id={'flbz'} label={'分类标志'} form={form}
                                    initialValue={initData.flbz ? arr : []}>
                            <Cascader options={this.state.options} placeholder="请选择分类标志"/>
                        </NHFormItem>
                    </div>
                    <div
                        style={{display: (this.state.flbzIsShowFlag || this.state.flbzUpdateIsShowFlag) ? "block" : "none"}}>
                        <NHFormItem id={'flmid'} label={'父栏目'} form={form}
                                    initialValue={initData.lmlx === '1' ? initData.flmid !== '-1' ? initData.flmid : '' : ''}>
                            <NHSelect sign={'zhxg_yxxt_dhlmgl_xxfblx_flm'}
                                      filterData={{type: 'remove', filterkeys: [initData.pkid]}}/>
                        </NHFormItem>
                    </div>
                    <div
                        style={{display: (this.state.lmljIsShowFlag || this.state.lmljUpdateIsShowFlag) ? 'block' : 'none'}}>
                        <NHFormItem id={'ljlxFlmid'} label={'父栏目'} form={form}
                                    initialValue={initData.lmlx === '2' ? initData.ljlxFlmid !== '-1' ? initData.ljlxFlmid : '' : ''}>
                            <NHSelect sign={'zhxg_yxxt_dhlmgl_ljlx_flm'}
                                      filterData={{type: 'remove', filterkeys: [initData.pkid]}}/>
                        </NHFormItem>
                    </div>
                    <NHFormItem id={'xsfs'} label={'显示方式'} form={form} required={true}
                                initialValue={initData.xsfs ? initData.xsfs : '1'}>
                        <RadioGroup>
                            <Radio value={'1'}>
                                登录前后显示
                            </Radio>
                            <Radio value={'2'}>
                                登录后显示
                            </Radio>
                        </RadioGroup>
                    </NHFormItem>
                    <NHFormItem id={'pxh'} label={'排序号'} hasFeedback={true} form={form}
                                initialValue={initData.pxh ? initData.pxh : 1}>
                        <InputNumber min={1}/>
                    </NHFormItem>
                    <NHFormItem id={'zt'} label={'状态'} form={form} valuePropName={'checked'} required={true}
                                initialValue={initData.zt ? (initData.zt === '1') : false}>
                        <Switch checkedChildren="启用" unCheckedChildren="停用"/>
                    </NHFormItem>
                </Form>
            </div>
        );
    }
}

const addOrEditForm = Form.create()(AddOrEditForm);

export default addOrEditForm;



// WEBPACK FOOTER //
// ./components/fwwgl/dhlm/AddOrEditForm.js